export default __webpack_public_path__ + "static/media/expl-gradcam_05_EN.088db9b1.png";